import React from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
/**
 * Use intersection observer to render on scroll, not before
 */

const LazyLoad = ({ children, callback, className, loader }) => {
  const [ref, inView] = useInView({
    /* Optional options */
    triggerOnce: true,
    rootMargin: '400px 0px'
  });

  if (inView && callback) callback();
  return (
    <div ref={ref}>
      {inView ? <div className={className}>{children}</div> : loader}
    </div>
  );
};

export default LazyLoad;

LazyLoad.propTypes = {
  // eslint-disable-next-line react/require-default-props
  callback: PropTypes.func,
  className: PropTypes.string,
  loader: PropTypes.node
};

LazyLoad.defaultProps = {
  className: 'lazy-fade',
  loader: <></>
}
